import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Typography, Row, Col, Switch } from "antd";

import DataTable from "../../../../Components/DataTable";
import * as userActions from "../../../../actionCreators/User";
import SurveyListing from "./SurveyListing";

import "./style/userSurveyListing.css";

const UserSurveyListing = ({
  users,
  getUsersSurveys,
  currentUser,
  updateSurveyStatus,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [openSurveyListing, setOpenSurveyListing] = React.useState(true);
  const [rowUserData, setRowUserData] = React.useState(null);
  const [activeToggle, setActiveToggle] = React.useState(
    currentUser.data.survey_status
  );
  const [toggleClass, setToggleClass] = React.useState(
    currentUser.data.survey_status ? "active-switch" : ""
  );

  React.useEffect(() => {
    getUsersSurveys({ page: 0, pageSize: 10 });
  }, []);

  React.useEffect(() => {
    if (users.data) {
      setData(users.data);
      setPagination(users.pagination);
      setLoading(users.loading);
    }
  }, [users]);

  React.useEffect(() => {
    setActiveToggle(currentUser.data.survey_status);
  }, [currentUser.data.survey_status]);

  const handleTablePageChange = (tableChangeData) => {
    const { current, pageSize } = tableChangeData;
    getUsersSurveys({ page: current - 1, pageSize });
  };

  const tableColumns = [
    {
      title: "Inspector Name",
      dataIndex: "full_name",
      width: "20%",
      render: (full_name) => (full_name ? full_name : "---"),
    },
    {
      title: "Circle",
      dataIndex: "circle",
      width: "20%",
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Due Date",
      dataIndex: "survey_date",
      render: (survey_date) => (survey_date ? survey_date : "---"),
    },
    {
      title: "Submissions",
      dataIndex: "surveys",
      render: (surveys) => (surveys !== null ? surveys : "---"),
    },
  ];

  const onTableRowClick = (data) => {
    setRowUserData(data);
    setOpenSurveyListing(false);
  };

  const handleToggleChange = (e) => {
    const survey_status = e;
    if (survey_status) {
      setToggleClass("active-switch");
    } else {
      setToggleClass("");
    }
    updateSurveyStatus({ survey_status });
  };

  return (
    <React.Fragment>
      {openSurveyListing ? (
        <div>
          <Row>
            <Col span={12}>
              <Typography className="heading">General Survey</Typography>
            </Col>
            <Col span={12}>
              <div className="top-button-wrap">
                <Switch
                  className={toggleClass}
                  defaultChecked={activeToggle}
                  onChange={handleToggleChange}
                />
                <p className="active-text">Active</p>
              </div>
            </Col>
          </Row>

          <DataTable
            columns={tableColumns}
            pagination={pagination}
            loading={loading}
            data={data}
            handleTableValuesChange={handleTablePageChange}
            onRowClick={onTableRowClick}
          />
        </div>
      ) : (
        <SurveyListing
          userData={rowUserData}
          openSurveyUsersListing={() => {
            setOpenSurveyListing(true);
          }}
        />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ user: { users, currentUser } }) => ({
  users,
  currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  getUsersSurveys: bindActionCreators(userActions.getUsersSurveys, dispatch),
  updateSurveyStatus: bindActionCreators(
    userActions.updateSurveyStatus,
    dispatch
  ),
});

UserSurveyListing.propTypes = {
  users: PropTypes.object.isRequired,
  getUsersSurveys: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  updateSurveyStatus: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSurveyListing);
